export default function setAgreements(agreement, agreementHiddenInput) {
    const agreementItem = [...agreement.querySelectorAll('.agreement-item')];
    const data = [];
    agreementItem.forEach((item) => {
        const selects = [...item.querySelectorAll('select')];
        const input = item.querySelectorAll('input');
        const dataItem = {
            title: input[0].value,
            tag: selects[0].value,
            category: selects[1].value,
        };
        data.push(dataItem);
    });
    agreementHiddenInput.value = JSON.stringify(data);
}
